// ts-rest contract for the Book Health surface (C8). Firm admin only.
//
// GET /api/admin/book-health — the live convergence view: desk-user book sizes,
// unresolved grid manager strings, and stale canonical attributions. Backs the
// the Admin shell Book Health card and the Desk empty-state hint.
//
// The worklist half (SEP-216 follow-up):
//   GET  /api/admin/book-health/exceptions               — the work items, named
//   POST /api/admin/book-health/exceptions/:id/decision  — settle one item
//   POST /api/admin/book-health/merge-accounts           — fold a rival Account
//
// A work item is stored as record ids alone, so the list endpoint is the seam
// that joins each id to its record and gives a person something to read.

import { initContract } from '@ts-rest/core';
import { errorBodyWithCode as errorBody } from '../schemas/common';
import { bookHealthResponseSchema } from '../schemas/book-health';
import {
    bookHealthExceptionDecisionSchema,
    bookHealthExceptionSchema,
    listBookHealthExceptionsQuerySchema,
    listBookHealthExceptionsResponseSchema,
    mergeAccountsRequestSchema,
    mergeAccountsResponseSchema,
} from '../schemas/book-health-exceptions';

const c = initContract();

export const bookHealthContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/admin/book-health',
            responses: {
                200: bookHealthResponseSchema,
            },
            summary: 'Live desk-book health: empty books, unresolved managers, stale attributions',
        },
        listExceptions: {
            method: 'GET',
            path: '/admin/book-health/exceptions',
            query: listBookHealthExceptionsQuerySchema,
            responses: {
                200: listBookHealthExceptionsResponseSchema,
            },
            summary: 'The client-model work items, with each record id named for a person',
        },
        decideException: {
            method: 'POST',
            path: '/admin/book-health/exceptions/:id/decision',
            body: bookHealthExceptionDecisionSchema,
            responses: {
                200: bookHealthExceptionSchema,
                400: errorBody,
                404: errorBody,
            },
            summary: 'Settle one work item: approve a holder, assign a parked identifier, dismiss',
        },
        mergeAccounts: {
            method: 'POST',
            path: '/admin/book-health/merge-accounts',
            body: mergeAccountsRequestSchema,
            responses: {
                200: mergeAccountsResponseSchema,
                400: errorBody,
            },
            summary: 'Fold a rival Account into the Account that holds the source Client Reference',
        },
    },
    {
        pathPrefix: '/api',
        strictStatusCodes: false,
    },
);
